import { useEffect, useState } from 'react';
import { GridInitialState } from '@mui/x-data-grid-pro';
import { Run, RunStatus, fetchRuns, getRunsSubject } from '../../../store/Run';
import { DefaultRunGridColumnDefs } from './RunGridColumnDefs';
import { UpstackDataGrid } from '../../Compounds/UpstackDataGrid/UpstackDataGrid';
import { getInitialState } from '../../Compounds/UpstackDataGrid/helpers';
import { PageCard } from '../../Compounds/CardWithTitle';
import { getCustomizationSubject, getDefaultPreferences, GridPreferences } from '../../../store/UserCustomizations';
import { ComponentSpinner } from '../../Compounds/Loading/ComponentSpinner';

export const DatePastRunTab = () => {
  const [runsLoading, setRunsLoading] = useState<boolean>(false);
  const [runs, setRuns] = useState<Run[]>([]);
  const [gridSettings, setGridSettings] = useState<GridPreferences>(
    getDefaultPreferences()?.content['datePastRunGrid'] as GridPreferences
  );
  const [initialState, setInitialState] = useState<GridInitialState>();

  const handleFetchRuns = async (localLoading?: boolean) => {
    if (localLoading) setRunsLoading(true);
    await fetchRuns();
    if (localLoading) setRunsLoading(false);
  };

  useEffect(() => {
    const runsSub = getRunsSubject().subscribe((runs) => {
      const activeStatuses = [RunStatus.PROCESSING, RunStatus.PENDING_LOCK, RunStatus.LOCKED];
      const activeRuns = runs.filter((r) => activeStatuses.includes(r.status));
      const earliestActiveRun = activeRuns[0];
      const earliestActiveId = earliestActiveRun?.id;
      const filteredRuns = runs.filter(
        (r) => r.status === RunStatus.DATE_ONLY && earliestActiveId && r.id < earliestActiveId
      );
      setRuns(filteredRuns);
    });
    const userCustSub = getCustomizationSubject().subscribe((userCust) => {
      if (userCust) {
        setGridSettings(userCust.content.datePastRunGrid);
        const state = getInitialState(userCust.content.datePastRunGrid, DefaultRunGridColumnDefs, 'datePastRunGrid');
        setInitialState(state);
        handleFetchRuns(true);
      }
    });

    return () => {
      if (runsSub) runsSub.unsubscribe();
      if (userCustSub) userCustSub.unsubscribe();
    };
  }, []);

  return (
    <PageCard
      dataTestId="date-past-run-management"
      dataCy="date-past-run-management"
      childrenWrapperClass="min-h-80 max-w-[60vw] min-w-full"
      title="Runs">
      <>
        {(!initialState || runsLoading) && (
          <div className="flex h-[45rem] m-auto">
            <ComponentSpinner label="Loading data..." />
          </div>
        )}
        {initialState && !runsLoading && (
          <UpstackDataGrid
            title=""
            rows={runs}
            columns={DefaultRunGridColumnDefs}
            page="datePastRunGrid"
            gridSettings={gridSettings}
            showSearch={false}
            initialState={initialState}
            apiFilter={false}
            sxStyles={{ borderWidth: '0', borderBottomLeftRadius: '.75rem', borderBottomRightRadius: '.75rem' }}
          />
        )}
      </>
    </PageCard>
  );
};
